import baseURL from "../../utils/API_URL";
import axios from "axios";

let hdcase = "";

function safeJsonParse(str, fallback) {
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
}

function parseEpicorResponse(res) {
  try {
    const raw = res?.data ?? res;
    const obj = typeof raw === "string" ? JSON.parse(raw) : raw;

    return {
      ok: !obj?.error || obj.error === "%!s(<nil>)",
      header:
        typeof obj?.header === "string"
          ? JSON.parse(obj.header)
          : obj?.header ?? null,
      data:
        typeof obj?.data === "string"
          ? JSON.parse(obj.data)
          : obj?.data ?? null,
      error: obj?.error && obj.error !== "%!s(<nil>)" ? obj.error : null,
      raw: obj,
    };
  } catch (err) {
    return {
      ok: false,
      header: null,
      data: null,
      error: err?.message || "Parse error",
      raw: res,
    };
  }
}

async function callApiCreateRequest(user) {
  const url = baseURL + "api/create-request";
  const body = {
    name: user.name,
    email: user.email,
    phone: user.phone,
    call_phone: user.phone,
    company_name: user.company,
    company_address: user.company_address,
    title: "Service Request",
    equip: user.equipment,
    serial: user.equipment_serial,
    message: user.comment,
  };
  const headers = {
    Authorization: "Bearer " + user.token,
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, body, { headers });
    hdcase = response?.data?.Data?.HDCaseNum ?? "";
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

async function callBAQ(baq, param, token) {
  const url = baseURL + "api/call-baq";
  const body = {
    CompanyID: "EPIC03",
    PlantID: "MfgSys",
    Company: "EPIC03",
    Plant: "MfgSys",
    QueryID: baq,
    IsTest: false,
    Mode: 0,
    UseNewDataFormat: true,
    Take: 0,
    Skip: 0,
    SortBy: null,
    SysRevID: 0,
    Parameters: param,
  };
  const headers = {
    Accept: "*/*",
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, body, { headers });
    return safeJsonParse(response?.data?.DataRaw, []);
  } catch (error) {
    console.error(error);
    return [];
  }
}

async function createMemoApi(bodyMemo, token) {
  const url = baseURL + "api/addcustmemo";
  const body = {
    category: bodyMemo.cate,
    memo_text: bodyMemo.text,
    memo_desc: bodyMemo.desc,
  };
  const headers = {
    Accept: "*/*",
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };

  await axios.post(url, body, { headers });
}

function getToken() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Missing token in localStorage");
  return token;
}

export default {
  async getJobListBoard({ commit }) {
    const dataset = await callBAQ(
      "DSPGetJobListBoard",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );

    const array = [];
    if (Array.isArray(dataset) && dataset.length > 0) {
      dataset.forEach((el) => {
        if (el.JobHead_StartDate) {
          array.push({
            Id: el.JobHead_JobNum,
            Subject: el.JobHead_JobNum,
            StartTime: new Date(
              new Date(el.JobHead_StartDate).setHours(el.JobHead_StartHour),
            ),
            EndTime: new Date(
              new Date(el.JobHead_DueDate).setHours(el.JobHead_DueHour),
            ),
            IsAllDay: false,
            ...el,
          });
        }
      });
    }

    commit("SET_JOB_LIST_BOARD", array);
    return array;
  },

  async getTechnianList({ commit }) {
    const dataset = await callBAQ("DSPTechnianList", {}, getToken());
    commit("SET_TECHNIAN_LIST", dataset);
    return dataset;
  },
  async getDriverList({ commit }) {
    const dataset = await callBAQ("DSPDriverList", {}, getToken());
    commit("SET_DRIVER_LIST", dataset);
    return dataset;
  },
  async getEquipList({ commit }) {
    const dataset = await callBAQ("DSPEquipList", {}, getToken());
    commit("SET_EQUIP_LIST", dataset);
    return dataset;
  },
  async getTransportPlans({ commit }) {
    const dataset = await callBAQ("DSP-TransportPlaning", {}, getToken());
    commit("SET_TRANSPORT_LIST", dataset);
    return dataset;
  },
  async getBookingPlans({ commit }) {
    const dataset = await callBAQ("DSPBookingList", {}, getToken());
    commit("SET_BOOKING_LIST", dataset);
    return dataset;
  },
  async getHomeData({ commit }) {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const dataset = await callBAQ(
      "DSPGetHomeData",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
        Today: `${month}/${day}/${year}`,
      },
      getToken(),
    );

    commit("SET_HOME", dataset?.[0] ?? {});
    return dataset?.[0] ?? {};
  },

  async getOpenRequestData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetRequest",
      {
        Status: "OPEN",
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_OPEN_REQUEST", dataset);
    return dataset;
  },

  async getCloseRequestData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetRequest",
      {
        Status: "CLOSED",
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_CLOSE_REQUEST", dataset);
    return dataset;
  },

  async getCloseCallData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetServiceCall",
      {
        Status: "false",
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_CLOSE_CALL", dataset);
    return dataset;
  },

  async getOpenCallData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetServiceCall",
      {
        Status: "true",
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_OPEN_CALL", dataset);
    return dataset;
  },

  async getTodayJobData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetJobList",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
        ToDay: payload.ToDay,
        isTodayJob: "true",
      },
      getToken(),
    );
    commit("SET_TODAY_JOBS", dataset);
    return dataset;
  },

  async getUpcomingJobData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetJobList",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
        ToDay: payload.ToDay,
        isTodayJob: "false",
      },
      getToken(),
    );
    commit("SET_UPCOMING_JOBS", dataset);
    return dataset;
  },

  setIsDoneFalse({ commit }) {
    commit("SET_IS_DONE", false);
  },

  resetCase({ commit }) {
    commit("SET_HDCASE", "");
  },

  async createRequest({ commit }, payload) {
    const isDone = await callApiCreateRequest(payload.user);
    commit("SET_IS_DONE", isDone);
    commit("SET_HDCASE", hdcase || "");
    hdcase = "";
    return isDone;
  },

  async createMemo({ commit }, payload) {
    await createMemoApi(
      {
        cate: payload.cateid,
        text: payload.text,
        desc: payload.description,
      },
      getToken(),
    );

    const dataset = await callBAQ(
      "DSPGetMemo",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );

    commit("SET_MEMO", dataset);
    return dataset;
  },

  async getEquipsData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetEquipments",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_EQUIPS", dataset);
    return dataset;
  },

  async getEquipHeaderData({ commit }) {
    const dataset = await callBAQ(
      "DSPMntEquip",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_EQUIP_HEADER", dataset);
    return dataset;
  },

  async getEquipDetailData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPSerialDetailCallJob",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
        SerialNum: payload.serial,
      },
      getToken(),
    );
    commit("SET_EQUIP_DETAIL", dataset);
    return dataset;
  },

  async getJobsList({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPMaintJobs",
      {
        CustNum: String(localStorage.getItem("cust_num") || ""),
        Equip: payload.equip_id,
      },
      getToken(),
    );
    commit("SET_JOBS_LIST", dataset);
    return dataset;
  },

  async getOpenInvoiceData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetInvoice",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_INVOICE_HEADER", dataset);
    return dataset;
  },

  async getPaidInvoiceData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetInvoiceDtl",
      {
        InvoiceNum: payload.invoice_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_INVOICE_DTL", dataset);
    return dataset;
  },

  async getContractHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetContractHead",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_CONTRACT_HEAD", dataset);
    return dataset;
  },

  async getContractDtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetContractDtl",
      {
        ContractNum: payload.contract_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_CONTRACT_DTL", dataset);
    return dataset;
  },

  async getContractRenewalData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetContractRenewal",
      {
        ContractNum: payload.contract_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_CONTRACT_RENEWAL", dataset);
    return dataset;
  },

  async getQuoteHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetQuoteHead",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_QUOTE_HEAD", dataset);
    return dataset;
  },

  async getQuoteDtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetQuoteDtl",
      {
        QuoteNum: payload.quote_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_QUOTE_DTL", dataset);
    return dataset;
  },

  async getOrderHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetOrderHead",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_ORDER_HEAD", dataset);
    return dataset;
  },

  async getOrderDtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetOrderDtl",
      {
        OrderNum: payload.order_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_ORDER_DTL", dataset);
    return dataset;
  },

  async getShipHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetShipHead",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_SHIP_HEAD", dataset);
    return dataset;
  },

  async getShipDtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetShipDtl",
      {
        PackNum: payload.pack_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_SHIP_DTL", dataset);
    return dataset;
  },

  async getRMAHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetRMAHead",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_RMA_HEAD", dataset);
    return dataset;
  },

  async getRMADtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetRMADtl",
      {
        RMANum: payload.rma_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_RMA_DTL", dataset);
    return dataset;
  },

  async getProjectJobHeadData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetProjectJobs",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_PROJECT_JOBS", dataset);
    return dataset;
  },

  async getProjectJobDtlData({ commit }, payload) {
    const dataset = await callBAQ(
      "DSPGetProjectJobDtls",
      {
        JobNum: payload.job_num,
        CustNum: String(localStorage.getItem("cust_num") || ""),
      },
      getToken(),
    );
    commit("SET_PROJECT_JOB_DTLS", dataset);
    return dataset;
  },

  async getInventoryData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetInventory",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_INVENTORY", dataset);
    return dataset;
  },

  async getMemoData({ commit }) {
    const dataset = await callBAQ(
      "DSPGetMemo",
      { CustNum: String(localStorage.getItem("cust_num") || "") },
      getToken(),
    );
    commit("SET_MEMO", dataset);
    return dataset;
  },

  async importer(_, payload) {
    const token = getToken();

    const body = {
      Data: {
        Tables: [{ Name: payload.tableName, Rows: payload.rows }],
        Relations: [],
      },
      CompanyID: "EPIC03",
      PlantID: "MfgSys",
      Company: "EPIC03",
      Plant: "MfgSys",
      IsTest: false,
      Update: !!payload?.flags?.update,
      Add: !!payload?.flags?.add,
      Delete: !!payload?.flags?.delete,
      ImporterName: payload.importerName,
      RollBackWhenFailed: !!payload?.flags?.rollbackWhenFailed,
    };

    const { data } = await axios.post(baseURL + "api/importer", body, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    const parsed = data?.DataRaw ? safeJsonParse(data.DataRaw, []) : data;

    if (parsed?.IsAllSuccess) payload.onSuccess?.(parsed);
    else payload.onFailure?.(parsed);

    return parsed;
  },

  async callBO(_, payload) {
    const token = getToken();

    const body = {
      BO: payload?.bo,
      Method: payload?.method,
      CompanyID: "EPIC03",
      PlantID: "MfgSys",
      Company: "EPIC03",
      Plant: "MfgSys",
      IsTest: false,
      Data: payload?.body,
      BpmData: {
        Context: {
          BpmData: payload?.bpmData,
        },
      },
    };

    const response = await axios.post(baseURL + "api/method", body, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    const parsed = parseEpicorResponse(response);

    const normalized = {
      raw: parsed,
      returnObj:
        parsed?.returnObj ||
        parsed?.data?.returnObj ||
        parsed?.parameters?.returnObj ||
        null,
      parameters: parsed?.parameters || parsed?.data?.parameters || null,
      error: parsed?.error || null,
      isFinished:
        parsed?.data?.parameters?.l_finished === true ||
        parsed?.parameters?.l_finished === true,
    };

    const hasError = !!normalized.error;
    const isMoveJobItem = payload?.method === "MoveJobItem";

    if (!hasError && (!isMoveJobItem || normalized.isFinished)) {
      payload.onSuccess?.(normalized);
    } else if (hasError || isMoveJobItem) {
      payload.onFailure?.(normalized);
    }

    return normalized;
  },
};
